import { Fragment } from "react";

import MenuItem from "_metronic/layout/aside/MenuItem";
import MenuItemSeparator from "_metronic/layout/aside/MenuItemSeparator";
import MenuSection from "_metronic/layout/aside/MenuSection";

const MenuSubmenu = ({ item, currentUrl, layoutConfig }) => {
  return (
    <ul className="kt-menu__subnav">
      {item.submenu.map((child, index) => (
        <Fragment key={index}>
          {child.section && <MenuSection item={child} parentItem={item} currentUrl={currentUrl} />}

          {child.separator && (
            <MenuItemSeparator item={child} parentItem={item} currentUrl={currentUrl} />
          )}

          {child.title && (
            <MenuItem
              item={child}
              parentItem={item}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </Fragment>
      ))}
    </ul>
  );
};

export default MenuSubmenu;
